/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {FormControl, InputLabel} from "@mui/material";
import ArgosMenuItem from "../../../../components/Form/Select/ArgosMenuItem";
import ArgosSelect from "../../../../components/Form/Select/ArgosSelect";
import React, {useEffect} from "react";
import ArgosFlexbox from "../../../../components/Containers/ArgosFlexbox";
import {usePostRequest} from "../../../../../api/helper";
import ArgosButton from "../../../../components/Buttons/ArgosButton";
import ArgosTextField from "../../../../components/Form/TextField/ArgosTextField";

interface IFormData {
  programCode: string,
  modelYear: string,
  notes: string,
}
const initialFormData: IFormData = {
  programCode: '',
  modelYear: '',
  notes: '',
}
const AddVehicleProgramDialog = (props: any) => {
  const {adasProgramId, closeDialog, onSaveComplete, dialogState, tableRows} = props
  const [formData, setFormData] = React.useState<any>(dialogState?.formData ?? initialFormData)
  const [vehicleProgramDatabaseData, setVehicleProgramDatabaseData] = React.useState<any>({})
  const {rowIndex, dialogType} = dialogState ?? {}
  const isDialogTypeEdit = dialogType === 'edit'

  useEffect(() => {
    if(!dialogState?.formData) return
    setFormData(dialogState.formData ?? initialFormData)
  }, [dialogState])

  const fetchVehicleProgramDatabaseDataHandle = usePostRequest('/HttpTriggerAdasPrograms?page=vehiclePrograms&requestType=vehicleProgramDatabaseData')
  useEffect(() => {
    fetchVehicleProgramDatabaseDataHandle().then((res) => {
      setVehicleProgramDatabaseData(res)
    }).catch((err) => {
      console.log(err)
    })
  }, []);

  const programCodes = Object.keys(vehicleProgramDatabaseData)
  const filteredProgramCodes = programCodes
  const modelYears = Object.keys(vehicleProgramDatabaseData?.[formData?.programCode] ?? {})
  const filteredModelYears = modelYears.filter((_modelYear) => {
    if(isDialogTypeEdit && formData?.modelYear === _modelYear) return true
    return !tableRows.some((row: any) => row.programCode === formData?.programCode && row.modelYear === _modelYear)
  })

  const addVehicleProgramHandle = usePostRequest()
  const onSave = () => {
    // const vehicleProgramData = vehicleProgramDatabaseData?.[formData?.programCode]?.[formData?.modelYear]
    // const vehicleProgramId = vehicleProgramData?.vehicleProgramId
    const vehicleProgramId = vehicleProgramDatabaseData?.[formData?.programCode]?.[formData?.modelYear]
    let payload: any = {
      formData: formData,
      adasProgramId,
      vehicleProgramId
    }
    if(isDialogTypeEdit) {
      payload = {
        ...payload,
        rowIndex,
        type: dialogType
      }
    }
    let url = ''
    switch(dialogType) {
      case 'edit':
        url = `/HttpTriggerAdasPrograms?page=vehiclePrograms&requestType=editVehicleProgram`
        break
      case 'add':
        url = `/HttpTriggerAdasPrograms?page=vehiclePrograms&requestType=addVehicleProgram`
        break
      default:
        return
    }
    addVehicleProgramHandle(payload, null, 'POST', '', url).then((res) => {
      onSaveComplete()
    }).catch((err) => {
      console.log(err)
    })
  }

  const {programCode: selectedProgramCode, modelYear: selectedModelYear, notes: selectedNotes} = formData
  const disabledBecauseEmpty = !filteredProgramCodes.includes(selectedProgramCode) ||
    !filteredModelYears.includes(selectedModelYear)

  return (
    <ArgosFlexbox vertical>
      <FormControl variant={'standard'}>
          <InputLabel>Vehicle Program</InputLabel>
          <ArgosSelect
            disabled={isDialogTypeEdit}
            value={selectedProgramCode ?? ''}
            label="Vehicle Program"
            onChange={(e: any) => {
              setFormData((prevState: any) => ({...prevState, programCode: e.target.value}))
            }}
          >
            {
              filteredProgramCodes?.map((value, i) => {
                return (
                  <ArgosMenuItem key={i} value={value}>{value}</ArgosMenuItem>
                )
              })
            }
          </ArgosSelect>
        </FormControl>
      <FormControl variant={'standard'}>
          <InputLabel>Program Model Year</InputLabel>
          <ArgosSelect
            disabled={isDialogTypeEdit}
            value={formData?.modelYear ?? ''}
            label="Program Model Year"
            onChange={(e: any) => {
              setFormData((prevState: any) => ({...prevState, modelYear: e.target.value}))
            }}
          >
            {
              filteredModelYears?.map((value, i) => {
                return (
                  <ArgosMenuItem key={i} value={value}>{value}</ArgosMenuItem>
                )
              })
            }
          </ArgosSelect>
        </FormControl>
      <ArgosTextField
          rows={4}
          multiline label={"Notes/Description"} value={selectedNotes}
          onChange={(e: any) => {
            setFormData((prevState: any) => ({...prevState, notes: e.target.value}))
          }}
        />
      <ArgosFlexbox style={{justifyContent: 'center'}}>
          <ArgosButton onClick={() => {
            closeDialog()
          }}
          >Cancel</ArgosButton>
          <ArgosButton onClick={onSave} disabled={disabledBecauseEmpty}>Save</ArgosButton>
        </ArgosFlexbox>
    </ArgosFlexbox>
  )
}

export default AddVehicleProgramDialog